<template>
  <roe-error-message
    class="input-wrap--small"
    :field="design.match_hours_requirement"
  >
    <input
      type="number"
      v-model="design.$model.match_hours_requirement"
      name="match_hours_requirement"
      min="1"
      required
    />
    <label v-if="showMonths" class="input-label-inside">Months</label>
    <label v-if="showHours" class="input-label-inside">Hours</label>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
export default {
  name: "RoeEmployerMatchServiceReqAppliesInput",
  components: { RoeErrorMessage },
  props: {
    design: Object
  },
  computed: {
    showHours() {
      return +this.design.$model.employer_match_annual_service_reqt === 2;
    },
    showMonths() {
      return +this.design.$model.employer_match_annual_service_reqt === 1;
    }
  }
};
</script>
